import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Homepage from './pages/Homepage';
import BhagyankCalculator from './pages/BhagyankCalculator';
import MoolankCalculator from './pages/MoolankCalculator';
import LuckyNumberCalculator from './pages/LuckyNumberCalculator';
import NameNumerologyCalculator from './pages/NameNumerologyCalculator';
import DestinyNumberCalculator from './pages/DestinyNumberCalculator';
import LifePathNumberCalculator from './pages/LifePathNumberCalculator';
import PersonalYearNumberCalculator from './pages/PersonalYearNumberCalculator';
import MobileNumberCompatibilityCalculator from './pages/MobileNumberCompatibilityCalculator';
import CarNumberLuckChecker from './pages/CarNumberLuckChecker';
import BusinessStartupNameNumerologyCalculator from './pages/BusinessStartupNameNumerologyCalculator';
import MarriageCompatibilityCalculator from './pages/MarriageCompatibilityCalculator';
import FinancialLuckCalculator from './pages/FinancialLuckCalculator';
import HealthNumberCalculator from './pages/HealthNumberCalculator';
import AngelNumberMeaningChecker from './pages/AngelNumberMeaningChecker';
import ChaldeanNumerologyCalculator from './pages/ChaldeanNumerologyCalculator';
import BirthDateStrengthAnalyzer from './pages/BirthDateStrengthAnalyzer';
import NameChangeSuggestionCalculator from './pages/NameChangeSuggestionCalculator';
import CareerNumberCalculator from './pages/CareerNumberCalculator';
import PhoneNumberOfChangeRecommendation from './pages/PhoneNumberOfChangeRecommendation';
import StartupNameGeneratorWithScore from './pages/StartupNameGeneratorWithScore';
import PlanetaryInfluenceScore from './pages/PlanetaryInfluenceScore';
import DailyLuckyNumberGenerator from './pages/DailyLuckyNumberGenerator';
import LuckyDatesForEvents from './pages/LuckyDatesForEvents';
import MobileNumberAnalysis from './pages/MobileNumberAnalysis';
import VehicleCarNumberAnalysis from './pages/VehicleCarNumberAnalysis';
import HouseNumberAnalysis from './pages/HouseNumberAnalysis';
import CompanyNameCompatibility from './pages/CompanyNameCompatibility';
import SignatureNumerology from './pages/SignatureNumerology';
import LuckyGemsColorsSuggestion from './pages/LuckyGemsColorsSuggestion';
import NumerologyReportGenerator from './pages/NumerologyReportGenerator';
import StartupNameAnalysis from './pages/StartupNameAnalysis';
import BusinessNameAnalysis from './pages/BusinessNameAnalysis';
import BrandNameSuccessPredictor from './pages/BrandNameSuccessPredictor';
import PartnershipCompatibilityTool from './pages/PartnershipCompatibilityTool';
import AstrologyPoweredBusinessLaunchDateFinder from './pages/AstrologyPoweredBusinessLaunchDateFinder';
import LogoNumerologyAnalyzer from './pages/LogoNumerologyAnalyzer';
import CalculatorsList from './pages/CalculatorsList';
import AboutContact from './pages/AboutContact';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/calculators" element={<CalculatorsList />} />
          <Route path="/bhagyank-calculator" element={<BhagyankCalculator />} />
          <Route path="/moolank-calculator" element={<MoolankCalculator />} />
          <Route path="/lucky-number-calculator" element={<LuckyNumberCalculator />} />
          <Route path="/name-numerology-calculator" element={<NameNumerologyCalculator />} />
          <Route path="/destiny-number-calculator" element={<DestinyNumberCalculator />} />
          <Route path="/life-path-number-calculator" element={<LifePathNumberCalculator />} />
          <Route path="/personal-year-number-calculator" element={<PersonalYearNumberCalculator />} />
          <Route path="/mobile-number-compatibility-calculator" element={<MobileNumberCompatibilityCalculator />} />
          <Route path="/car-number-luck-checker" element={<CarNumberLuckChecker />} />
          <Route path="/business-startup-name-numerology-calculator" element={<BusinessStartupNameNumerologyCalculator />} />
          <Route path="/marriage-compatibility-calculator" element={<MarriageCompatibilityCalculator />} />
          <Route path="/financial-luck-calculator" element={<FinancialLuckCalculator />} />
          <Route path="/health-number-calculator" element={<HealthNumberCalculator />} />
          <Route path="/angel-number-meaning-checker" element={<AngelNumberMeaningChecker />} />
          <Route path="/chaldean-numerology-calculator" element={<ChaldeanNumerologyCalculator />} />
          <Route path="/birth-date-strength-analyzer" element={<BirthDateStrengthAnalyzer />} />
          <Route path="/name-change-suggestion-calculator" element={<NameChangeSuggestionCalculator />} />
          <Route path="/career-number-calculator" element={<CareerNumberCalculator />} />
          <Route path="/phone-number-change-recommendation" element={<PhoneNumberOfChangeRecommendation />} />
          <Route path="/startup-name-generator-with-score" element={<StartupNameGeneratorWithScore />} />
          <Route path="/planetary-influence-score" element={<PlanetaryInfluenceScore />} />
          <Route path="/daily-lucky-number-generator" element={<DailyLuckyNumberGenerator />} />
          <Route path="/lucky-dates-for-events" element={<LuckyDatesForEvents />} />
          <Route path="/mobile-number-analysis" element={<MobileNumberAnalysis />} />
          <Route path="/vehicle-car-number-analysis" element={<VehicleCarNumberAnalysis />} />
          <Route path="/house-number-analysis" element={<HouseNumberAnalysis />} />
          <Route path="/company-name-compatibility" element={<CompanyNameCompatibility />} />
          <Route path="/signature-numerology" element={<SignatureNumerology />} />
          <Route path="/lucky-gems-colors-suggestion" element={<LuckyGemsColorsSuggestion />} />
          <Route path="/numerology-report-generator" element={<NumerologyReportGenerator />} />
          <Route path="/startup-name-analysis" element={<StartupNameAnalysis />} />
          <Route path="/business-name-analysis" element={<BusinessNameAnalysis />} />
          <Route path="/brand-name-success-predictor" element={<BrandNameSuccessPredictor />} />
          <Route path="/partnership-compatibility-tool" element={<PartnershipCompatibilityTool />} />
          <Route path="/astrology-powered-business-launch-date-finder" element={<AstrologyPoweredBusinessLaunchDateFinder />} />
          <Route path="/logo-numerology-analyzer" element={<LogoNumerologyAnalyzer />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about-contact" element={<AboutContact />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
